export default class CacheStorage {


 	addToArray(key, value)
	{
  		var items = JSON.parse(localStorage.getItem(key)) || [];
  
  		if (items.indexOf(value) == -1) {

    		items.push(value); 
  
    		localStorage.setItem(key, JSON.stringify(items));
  		}

  		return this;
	}	


	removeFromArray(key, value)
	{
		var items = JSON.parse(localStorage.getItem(key)) || [];

		if (items.indexOf(value) > -1) {

			items.splice(items.indexOf(value), 1);

			localStorage.setItem(key, JSON.stringify(items));

		}

		return this;
	}


	isCachedInArray(key, value)
	{
		var items = JSON.parse(localStorage.getItem(key)) || [];

		return items.indexOf(value) > -1;
	}


	getCachedArray(key)
	{
 	 	return JSON.parse(localStorage.getItem(key)) || [];
	}


}